// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/scripts/" + chunkId + "." + {"713":"1419dc62801c9a4372fa","879":"c8e08e7807365aa6cb66"}[chunkId] + ".js";
};